import JavaScriptCodeEditor from './JavaScriptCodeEditor';

export default JavaScriptCodeEditor;